
/**
* 用工中心 导出列表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/task/professionalList' }"
        >自由职业者列表</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: '/task/contractMigrationLog' }"
        >导入记录</el-breadcrumb-item
      >
      <el-breadcrumb-item>导入详情</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="状态 :">
        <el-select
          size="small"
          v-model="formInline.status"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="(val, index) in statusList"
            :label="val.label"
            :value="val.value"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label-width="30px">
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small" @click="reset()">清空</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column prop="id" label="记录Id"> </el-table-column>
      <el-table-column prop="status" label="状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :style="{ color: getStatusColor(scope.row.status) }">
            {{ getStatusText(scope.row.status) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="msg" label="错误信息" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="createdAtStr" label="导入时间"> </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
  </div>
</template>

<script>
import { importContractLogsDtl } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileList: [],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: "添加",

      statusList: [
        {
          label: "处理中",
          value: 0,
        },
        {
          label: "成功",
          value: 1,
        },
        {
          label: "失败",
          value: 2,
        },
      ],

      // rules表单验证
      rules: {},
      formInline: {
        status: "",
        page: 1,
        pageSize: 10,
      },
      // 删除部门

      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      multipleSelection: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  methods: {
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: "处理中",
        1: "成功",
        2: "失败",
      };
      return statusMap[status] || "未知";
    },

    // 获取状态对应的颜色
    getStatusColor(status) {
      const colorMap = {
        0: "#409EFF", // 处理中：蓝色
        1: "#67c23a", // 完成：绿色
        2: "#f56c6c", // 失败：红色
      };
      return colorMap[status] || "#909399"; // 默认灰色
    },

    getdata(parameter) {
      if (!this.$route.query.id) {
        this.$message.error("参数错误，id为空");
        return;
      }

      this.loading = true;
      importContractLogsDtl(parameter, this.$route.query.id)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    reset() {
      const page = this.formInline.page;
      const pageSize = this.formInline.pageSize;
      this.formInline = {
        page: page,
        pageSize: pageSize,
        status: "",
      };
      this.getdata(this.formInline);
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/task/contractMigrationLogDtl.vue